import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { MultipleLocationInputSize } from '@freelancer/ui/multiple-location-input';
import { TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-project-location',
  template: `
    <fl-heading
      i18n="Post Job Page form location field label"
      [headingType]="HeadingType.H3"
      [flMarginBottom]="Margin.XXXSMALL"
      [size]="TextSize.MID"
    >
      Where will this project be done?
    </fl-heading>
    <fl-bit [flMarginBottom]="Margin.LARGE">
      <fl-multiple-location-input
        flTrackingLabel="ProjectLocation"
        [firstLocationControl]="firstLocationControl"
        [secondLocationControl]="secondLocationControl"
        [inputSize]="MultipleLocationInputSize.LARGE"
      ></fl-multiple-location-input>
    </fl-bit>
  `,
})
export class ProjectLocationComponent {
  TextSize = TextSize;
  HeadingType = HeadingType;
  Margin = Margin;
  MultipleLocationInputSize = MultipleLocationInputSize;

  @Input() firstLocationControl: FormControl;
  @Input() secondLocationControl: FormControl;
}
